import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess({ agro_exporter_id, agro_exporter_process_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/process_by_main_rep/list_templates/agro_exporter_process/${agro_exporter_id}/${agro_exporter_process_id}`
    );
  },
  fetchQualityTemplateMainRep({
    agro_exporter_id,
    agro_exporter_process_id,
    quality_template_main_rep_id
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/process_by_main_rep/show_template_main_rep/${agro_exporter_id}/${agro_exporter_process_id}/quality_template_main_rep/${quality_template_main_rep_id}`
    );
  },
  fetchProducers({ agro_exporter_id, agro_exporter_process_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/process_by_main_rep/show_template_main_rep/${agro_exporter_id}/${agro_exporter_process_id}/list_producers`
    );
  },
  fetchOrganizations({ agro_exporter_id, agro_exporter_process_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/process_by_main_rep/show_template_main_rep/${agro_exporter_id}/${agro_exporter_process_id}/list_organizations`
    );
  },
  downloadRepXlsx({
    agro_exporter_id,
    agro_exporter_process_id,
    quality_template_main_rep_id,
    search_params
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/process_by_main_rep/show_template_main_rep/${agro_exporter_id}/${agro_exporter_process_id}/template_rep_xlsx/${quality_template_main_rep_id}/` +
        `search?producer=${search_params.producer}&organization=${search_params.organization}&registered_at=${search_params.registered_at}`,
      { responseType: "blob" }
    );
  },
  fetchRepGuiHeaders({
    agro_exporter_id,
    agro_exporter_process_id,
    quality_template_main_rep_id
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/process_by_main_rep/show_template_main_rep/${agro_exporter_id}/${agro_exporter_process_id}/template_rep_gui_headers/${quality_template_main_rep_id}`
    );
  },
  fetchRepGuiData({
    agro_exporter_id,
    agro_exporter_process_id,
    quality_template_main_rep_id,
    search_params
  }) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/process_by_main_rep/show_template_main_rep/${agro_exporter_id}/${agro_exporter_process_id}/template_rep_gui_data/${quality_template_main_rep_id}/` +
        `search?producer=${search_params.producer}&organization=${search_params.organization}&registered_at=${search_params.registered_at}`
    );
  }
};
